// src/i18n/locales/ar/dietaryPreferences.ts
export const arDietaryPreferencesTranslations = {
  dietaryPreferences: {
    // Page titles
    title: 'التفضيلات الغذائية',
    subtitle: 'إدارة التفضيلات والقيود الغذائية لعناصر القائمة الخاصة بك',
    
    // Actions
    addPreference: 'إضافة تفضيل',
    edit: 'تعديل',
    delete: 'حذف',
    save: 'حفظ',
    cancel: 'إلغاء',
    
    // Modal titles
    addNewPreference: 'إضافة تفضيل غذائي جديد',
    editPreference: 'تعديل التفضيل الغذائي',
    deletePreference: 'حذف التفضيل الغذائي',
    
    // Form labels
    name: 'الاسم',
    namePlaceholder: 'مثال: نباتي، خالي من الغلوتين، حلال',
    description: 'الوصف',
    descriptionPlaceholder: 'اوصف هذا التفضيل الغذائي',
    arabicName: 'الاسم باللغة العربية',
    arabicNamePlaceholder: 'مثال: نباتي، خالي من الغلوتين، حلال',
    arabicDescription: 'الوصف باللغة العربية',
    arabicDescriptionPlaceholder: 'اوصف هذا التفضيل الغذائي باللغة العربية',
    
    // Validation messages
    nameRequired: 'الاسم مطلوب',
    descriptionRequired: 'الوصف مطلوب',
    
    // Empty states
    noPreferences: 'لا توجد تفضيلات غذائية حتى الآن',
    
    // Confirmation messages
    deleteConfirmation: 'هل أنت متأكد من حذف هذا التفضيل الغذائي؟ لا يمكن التراجع عن هذا الإجراء.',
    
    // Success/Error messages
    addSuccess: 'تمت إضافة التفضيل الغذائي بنجاح',
    addError: 'فشل في إضافة التفضيل الغذائي',
    updateSuccess: 'تم تحديث التفضيل الغذائي بنجاح',
    updateError: 'فشل في تحديث التفضيل الغذائي',
    deleteSuccess: 'تم حذف التفضيل الغذائي بنجاح',
    deleteError: 'فشل في حذف التفضيل الغذائي',
  },
};
